import { styled } from '@mui/material'
import React from 'react'
import { SelectInput } from 'react-admin'
import { APIPricingRuleSet } from 'services/api/entities/catalog/types'
import { weekDaysList } from 'services/cfg/form'
import {
  ArrayInputContentProps,
  useKArrayInput,
} from 'services/hooks/useKArrayInput'

const PREFIX = 'WeekDaysRangeInput'

const classes = {
  flex: `${PREFIX}-flex`,
}

const StyledDiv = styled('div')(() => ({
  [`& .${classes.flex}`]: {
    display: 'flex',
  },
}))

type Props = ArrayInputContentProps

const WeekDaysRangeInput: React.FC<Props> = ({ source }) => {
  const { kGetSource } = useKArrayInput<APIPricingRuleSet>(source)

  return (
    <StyledDiv className={classes.flex}>
      <SelectInput
        source={kGetSource('dayFrom')}
        choices={weekDaysList}
        label="form.fields.dayFrom"
        style={{ marginRight: '16px' }}
      />
      <SelectInput
        source={kGetSource('dayTo')}
        choices={weekDaysList}
        label="form.fields.dayTo"
      />
    </StyledDiv>
  )
}

export default WeekDaysRangeInput
